import styled from 'styled-components';
import { IThemeProvider } from '../../styles/theme';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Container = styled.div`
  ${({ theme }: IThemeProvider) => `
    padding: 0 ${theme.layout.spacing.centy};
  `}
`;
